@if (!loading) {
  <div
    class="text-lg md:text-xl font-bold text-mat-ef-revolution-primary-500"
    >
    <T
    str="More details"
    key="customerPortal.customer-portal.vehicle.details.extended"
    tags="customer-portal, 3.1"
  ></T>
</div>
}

@if (loading) {
  <div class="heading-skeleton">
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
    ></ngx-skeleton-loader>
    <br />
  </div>
}

<div class="vehicle-extended-details pl-0">
  <div class="vehicle-details">
    @if (
      !vehicleDetailed?.details?.appearance?.name &&
      !vehicleDetailed?.details?.engine?.fuel?.name &&
      !vehicleDetailed?.details?.transmission?.name &&
      !vehicleDetailed?.details?.power?.ps &&
      !vehicleDetailed?.details?.driveType?.name &&
      !loading
      ) {
      <div
        class="mt-4 md:mt-14 w-full h-fit px-4 py-10 md:py-0 md:h-80 bg-mat-ef-revolution-grey-200 rounded-xl flex flex-col justify-center items-center"
        >
        <div class="text-mat-ef-revolution-supergrey-900">
          <mat-icon svgIcon="no_sim"></mat-icon>
        </div>
        <div class="text-base font-efSans-primary">
          <T
          str="You currently have no extended details"
          key="customerPortal.customer-portal.no-extended-details"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    </div>
  }

  @if (loading) {
    <div class="panel-icon">
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
      ></ngx-skeleton-loader>
    </div>
  }

  @if (
    (vehicleDetailed?.details?.appearance?.name) &&
    !loading
    ) {
    <div class="p-2.5 flex items-center justify-between gap-2.5">
      <div class="icon flex gap-2.5 items-center">
        <mat-icon class="vehicle-extended-icon" svgIcon="palette"></mat-icon>
        <span
          class="text-sm md:text-base text-efSans text-mat-ef-revolution-grey-two-500"
          >
          <T
          str="Color"
          key="customerPortal.customer-portal.color"
          tags="customer-portal, 3.1"
        ></T>
      </span>
    </div>

    <div class="text-mat-ef-revolution-primary-500 text-sm md:text-base text-efSans flex gap-2 items-center">
      {{ vehicleDetailed?.details?.appearance?.name }}
    </div>
  </div>
}

@if (loading) {
  <div class="panel-icon">
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
    ></ngx-skeleton-loader>
  </div>
}

@if (
  (vehicleDetailed?.details?.engine?.fuel?.name) &&
  !loading
  ) {
  <div class="p-2.5 flex items-center justify-between gap-2.5">
    <div class="icon flex gap-2.5 items-center">
      <mat-icon class="vehicle-extended-icon" svgIcon="fuel"></mat-icon>
      <span
        class="text-sm md:text-base text-efSans text-mat-ef-revolution-grey-two-500"
        >
        <T
        str="Fuel"
        key="customerPortal.customer-portal.fuel"
        tags="customer-portal, 3.1"
      ></T>
    </span>
  </div>

  <div class="text-mat-ef-revolution-primary-500 text-sm md:text-base text-efSans">
    {{ vehicleDetailed?.details?.engine?.fuel?.name }}
  </div>
</div>
}

@if (loading) {
  <div class="panel-icon">
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
    ></ngx-skeleton-loader>
  </div>
}

@if (
  (vehicleDetailed?.details?.transmission?.name) &&
  !loading
  ) {
  <div class="p-2.5 flex items-center justify-between gap-2.5">
    <div class="icon flex gap-2.5 items-center">
      <mat-icon class="vehicle-extended-icon" svgIcon="transmission"></mat-icon>
      <span
        class="text-sm md:text-base text-efSans text-mat-ef-revolution-grey-two-500"
        >
        <T
        str="Transmission"
        key="customerPortal.customer-portal.transmission"
        tags="customer-portal, 3.1"
      ></T>
    </span>
  </div>

  <div class="text-mat-ef-revolution-primary-500 text-sm md:text-base text-efSans">
    {{ vehicleDetailed?.details?.transmission?.name }}
  </div>
</div>
}

@if (loading) {
  <div class="panel-icon">
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
    ></ngx-skeleton-loader>
  </div>
}

@if (
  vehicleDetailed?.details?.power?.ps &&
  !loading
  ) {
  <div
    class="p-2.5 flex items-center justify-between gap-2.5"
    >
    <div class="icon flex gap-2.5 items-center">
      <mat-icon class="vehicle-extended-icon" svgIcon="power"> </mat-icon>
      <span
        class="text-sm md:text-base text-efSans text-mat-ef-revolution-grey-two-500"
        >
        <T
        str="Performance"
        key="customerPortal.customer-portal.performance"
        tags="customer-portal, 3.1"
        ></T
      ></span>
    </div>
    <div
      class="text-mat-ef-revolution-primary-500 text-sm md:text-base text-efSans"
      >
      {{ vehicleDetailed?.details?.power?.ps }}&nbsp;PS
    </div>
  </div>
}

@if (loading) {
  <div class="panel-icon">
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
    ></ngx-skeleton-loader>
  </div>
}

@if (loading) {
  <div class="panel-icon">
    <ngx-skeleton-loader
      appearance="line"
      animation="progress"
    ></ngx-skeleton-loader>
  </div>
}

@if (
  (vehicleDetailed?.details?.driveType?.name) &&
  !loading
  ) {
  <div class="p-2.5 flex items-center justify-between gap-2.5">
    <div class="icon flex gap-2.5 items-center">
      <mat-icon class="vehicle-extended-icon" svgIcon="wheel_drive"></mat-icon>
      <span
        class="text-sm md:text-base text-efSans text-mat-ef-revolution-grey-two-500"
        >
        <T
        str="Motorization"
        key="customerPortal.customer-portal.drive"
        tags="customer-portal, 3.1"
      ></T>
    </span>
  </div>

  <div class="text-mat-ef-revolution-primary-500 text-sm md:text-base text-efSans">
    {{ vehicleDetailed?.details?.driveType?.name }}
  </div>
</div>
}

</div>

@if (digitalManuals | digitalManuals: vehicleDetailed?.brand) {
  <a
    [href]="(digitalManuals | digitalManuals: vehicleDetailed.brand).link"
    target="_blank"
    mat-button
    mat-raised-button
    color="secondary"
    class="revolution w-full mt-10"
      (click)="
        sendContentModulesCTAData(
          'customerPortal.customer-portal.operation-manual'
        )
      "
    >
    <T
    str="Operation manual"
    key="customerPortal.customer-portal.operation-manual"
    tags="customer-portal, 3.1.0"
  ></T>
  <mat-icon svgIcon="arrow_right"></mat-icon>
</a>
}
</div>
